import store from '../store';

const communityModeration = (to, from, next) => {
  const params = {
    communityId: to.params.communityId,
  };

  store.dispatch('community/fetchById', params).then(() => {
    if (store.state.community.activeCommunityUser.permission === 'moderation') {
      return next();
    }
    return next(`/community/${to.params.communityId}`);
  });
};

const postAvailable = (to, from, next) => {
  if (!to.params.slug) {
    return next();
  }

  return store.dispatch('classIndex/checkIfCanBeAccessed', to.params.slug).then((response) => {
    if (!response.data.by_slug || !response.data.by_slug.available) {
      return next('/*');
    }
    return next();
  });
};


export default {
  communityModeration,
  postAvailable,
};



// WEBPACK FOOTER //
// ./src/router/navigationGuards.js